import { track } from '@eventbrite/datalayer-library';
import {
    BASE_URL,
    EXTERNAL_PAYMENT_PATH,
    STATUS_PATH,
} from '../../../constants';
import {
    STATUS_CONTROL_ORDER_TIME_EXPIRED,
    TIME_EXPIRED_STATUS,
    timeExpiredContent,
} from '../../../containers/status/constants';
import { trackTimerExpired } from '../../eventAnalytics';
import { HeapEventName } from '../../../constants/heap';
import { replace } from 'react-router-redux';
import { joinPath } from '@eventbrite/path-utils';

const _isExternalPaymentPageActiveWindow = () => document.hidden;

/**
 * The timer expired. This sends the user back to the checkout and show the timer expired message.
 */
export const onTimerExpiredFromExternalPayment = () => (dispatch, getState) => {
    const {
        order: { status: orderStatus },
    } = getState();

    if (!STATUS_CONTROL_ORDER_TIME_EXPIRED.includes(orderStatus)) {
        dispatch(trackTimerExpired(EXTERNAL_PAYMENT_PATH));
        track({
            eventName: HeapEventName.timerExpired,
            eventData: {
                checkoutStep: EXTERNAL_PAYMENT_PATH,
            },
        });
        dispatch(replace(joinPath(BASE_URL, STATUS_PATH, TIME_EXPIRED_STATUS)));
        if (_isExternalPaymentPageActiveWindow()) {
            alert(timeExpiredContent({}).alertText); // eslint-disable-line no-alert
        }
    }
};
